import { render, staticRenderFns } from "./Comms.vue?vue&type=template&id=25f9be24&"
import script from "./Comms.vue?vue&type=script&lang=js&"
export * from "./Comms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports